import TooltipLink from "@/components/TooltipLink/TooltipLink";
import { useCompanySettings } from "@/hooks/useCompanySettings";
import { CheckCircleOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Space, Tooltip } from "antd";
import { useLocation } from "react-router-dom";
import { useGetProduct } from "../useProducts";

export default function useProductDetailTabs({ productId }: { productId: number }) {
  const location = useLocation();
  const { data: companySettings } = useCompanySettings();
  const includeEol = companySettings?.include_eol || false;
  const includeUsage = companySettings?.include_usage || false;

  const { data } = useGetProduct({
    productId,
  });

  const product = data?.product;

  const eolStatus =
    !includeEol || data?.product.is_out_of_scope ? null : product?.eol_status === "complete" ? (
      <CheckCircleOutlined style={{ color: "#52C41A" }} />
    ) : (
      <InfoCircleOutlined style={{ color: "#FA8C16" }} />
    );

  const usageStatus =
    !includeUsage || data?.product.is_out_of_scope ? null : product?.usage_status === "complete" ? (
      <CheckCircleOutlined style={{ color: "#52C41A" }} />
    ) : (
      <InfoCircleOutlined style={{ color: "#FA8C16" }} />
    );

  const bomStatus = data?.product.is_out_of_scope ? null : product?.bom_status === "complete" ? (
    <CheckCircleOutlined style={{ color: "#52C41A" }} />
  ) : (
    <InfoCircleOutlined style={{ color: "#FA8C16" }} />
  );

  const tabs = [
    {
      key: "relations",
      label: (
        <Space>
          <span>Relations</span>
        </Space>
      ),
    },
    {
      key: "bom",
      label: (
        <Space>
          {bomStatus}
          <span>Bill of materials</span>
        </Space>
      ),
    },
    {
      key: "usage",
      label: (
        <Space>
          {usageStatus}
          <span>Usage</span>
        </Space>
      ),
    },
    {
      key: "eol",
      label: (
        <Space>
          {eolStatus}
          <span>End of life</span>
        </Space>
      ),
    },
    {
      key: "scenarios",
      label: (
        <Tooltip
          placement="right"
          title={
            !!data?.product.proxy_id ? (
              <>
                Scenarios are disabled for proxy products. Click{" "}
                <TooltipLink to={`/products/${data.product.proxy_id}/scenarios`}>here</TooltipLink>{" "}
                to start building scenarios on the source product.
              </>
            ) : undefined
          }
        >
          Scenarios
        </Tooltip>
      ),
      disabled: !!data?.product.proxy_id,
    },
  ];

  const locationTab = location.pathname.split("/")[3];
  const activeTab = tabs.find((item) => item.key === locationTab)?.key || tabs[0].key;

  return { tabs, activeTab };
}
